import { VisuallyHidden } from '../VisuallyHidden';
import styles from './Spinner.module.scss';

type Props = {
  /**
   * Accessibility label for the node
   * @default 'Loading'
   * */
  'aria-label'?: string;
  /** Diameter and border width of loader. */
  size?: 'small' | 'medium' | 'large';
  /** The color of the spinner. Use `light` when rendering over a dark background. Use `dark` when rendering over a light background. */
  color?: 'light' | 'dark';
};

/**
 * Renders a spinning loading indicator, used to inform the user they're waiting
 * for an action to complete.
 */
export const Spinner = ({
  'aria-label': ariaLabel = 'Loading',
  color = 'dark',
  size = 'small',
}: Props) => {
  return (
    <div
      className={styles.root}
      data-testid="spinner"
      role="status"
      data-zds
      data-color={color}
      data-size={size}
    >
      <VisuallyHidden>{ariaLabel}</VisuallyHidden>
    </div>
  );
};
